import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { AuthAction } from '../../store/actions';

class Login extends PureComponent {
  static propTypes = {
    login: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = { email: '', password: '' };
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.login(this.state);
  }

  render() {
    return (
      <div className="hold-transition login-page">
        <div className="login-box">
          <div className="card card-outline card-primary">
            <div className="card-header text-center">
              <b className="h1">Sign In</b>
            </div>
            <div className="card-body">
              <form onSubmit={this.onSubmit.bind(this)}>
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    name="email"
                    onChange={this.onChange}
                    placeholder="Email"
                    type="email"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-envelope"></span>
                    </div>
                  </div>
                </div>
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    name="password"
                    onChange={this.onChange}
                    placeholder="Password"
                    type="password"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <button className="btn btn-block btn-primary" type="submit">
                      Sign In
                    </button>
                  </div>
                  <div className="col-6 text-right">
                    <Link to="/forgot-password">Forgot Password?</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  login: data => dispatch(AuthAction.login(data)),
});

export default connect(null, mapDispatchToProps)(Login);
